export const EVENTS_PAGE_LIMIT = 100;

export const fetchAllEventPages = async ({ fetchPage, onPage }) => {
  const all = [];
  const seenTokens = new Set();
  let nextToken = null;

  do {
    const page = await fetchPage(nextToken);
    all.push(...(page.items ?? []));
    nextToken = page.nextToken ?? null;

    if (nextToken) {
      if (seenTokens.has(nextToken)) {
        throw new Error("Event pagination returned a repeated next token");
      }
      seenTokens.add(nextToken);
    }

    if (onPage) onPage(all, { nextToken });
  } while (nextToken);

  return all;
};
